import _ from 'underscore';

function Vehicle(data) {
    if (data) {
        _.extend(this, data);
    }
    this.costNew = this.costNew || {};
}

Vehicle.prototype.getDisplayName = function (defaultName) {
    var name = this.make || '';
    if (this.model) {
        if (name) {
            name += ' ';
        }
        name += this.model;
    }
    if (this.year) {
        if (name) {
            name += ' ';
        }
        name += this.year;
    }
    if (name.length < 1) {
        name = defaultName;
    } else if (this.license) {
        name += ' (';
        name += this.license;
        if (this.licenseState) {
            name += '/';
            name += this.licenseState;
        }
        name += ')';
    }
    return name;
};

Vehicle.prototype.getVehicleStatesForCountry = function (states, countryCode) {
    return _.filter(states, function (state) {
        var countryConstraint = _.find(state.categories, function (constraint) {
            return _.keys(constraint).indexOf('Country') !== -1;
        });
        if (countryConstraint) {
            return countryConstraint.Country === countryCode;
        }
        return false;
    });
};

export default Vehicle;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/endorsement/pa/models/Vehicle.js
// module id = 1478
// module chunks = 0